<template>
  <md-field :class="[
                {'md-error': errors.has('paymentId')},
                {'md-valid': !errors.has('paymentId') && touched.paymentId}]" >
    <md-select
      v-model="paymentId"
      data-vv-name="paymentId"
      v-validate= "modelValidations.paymentId">
      <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <slide-y-up-transition>
      <div class="vErrorText" v-show="errors.has('paymentId')">【必須】必ず一つ選択してください</div>
    </slide-y-up-transition>
    <slide-y-down-transition>
      <md-icon class="error" v-show="errors.has('paymentId')" style="margin-right:20px">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="!errors.has('paymentId') && touched.paymentId" style="margin-right:20px">done</md-icon>
    </slide-y-down-transition>
  </md-field>
</template>
<script>
  import NestedValidator from '../../mixins/nested-validator'
  export default {
    inject: ['$validator'],
    mixins: [NestedValidator],
    data() {
      return {
        listData: [],
        modelValidations: {
          paymentId: {
            required: true
          }
        },
        touched: {
          paymentId: false,
        },
      }
    },
    model: {
    },
    props:  ['value','noSelectFlag','saveCondition','touchedFlag'],    // undefinedはfalse扱い
    methods: {
      getPayments () {
        var condition = {
          kinds: (this.kinds==='選択しない' || this.kinds==null) ? '' : this.kinds
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/payments/select_list',
          timeout : 10000,
          params: condition,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.createList(response.data)
          sessionStorage.setItem('paymentSelect', JSON.stringify(response.data))
        })
        .catch(error => {
          this.dangerNotify('支払いリストを取得できませんでした')
        })
      },
      createList (obj) {
        this.listData = []
        if (this.noSelectFlag) {
          var item = {
            id: '選択しない',
            name: '選択しない',
          }
          this.listData.push(item)
          if (!this.saveCondition) {
            this.companyId = '選択しない'
          }
        }
        for (var i in obj) {
          var item = {
            id: obj[i].id,
            name: obj[i].name
          }
          this.listData.push(item)
        }
      },
      setPayment () {
        var paymentSelect = sessionStorage.getItem('paymentSelect')
        if (paymentSelect === null) {
          this.getPayments()
        } else {
          paymentSelect = JSON.parse(paymentSelect)
          this.createList(paymentSelect)
        }
      },
      resetPayment () {
        sessionStorage.removeItem('paymentSelect')
        this.setPayment()
      }
    },
    mounted () {
      this.setPayment()
      this.touched.paymentId = false
    },watch: {
      paymentId(){
        this.touched.paymentId = this.touchedFlag
      },
      '$route.path'(value){
        if (value.match('new')) {
          this.$validator.reset()
          this.touched.paymentId = false 
        }
      }
    },computed: {
      paymentId: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      }
    }

  }
</script>
<style scoped>
.paymentSelect{
  /* max-width: 120px; */
  width: 100%;
}
</style>